export const SMALL_SPACING = 2;
export const DEFAULT_SPACING = 4;
export const LARGE_SPACING = 8;
export const EXTRA_LARGE_SPACING = 16;

export const BORDER_RADIUS = 4;
